import { axiosBasic } from "../config/axios-common";

const postInsertOrUpdateSupplierDeclaration = async (data: any, professionalId: string) => {

  try {
      const config = {
          headers: {
              'Content-Type': 'application/json',
          }
      }
      const response = await axiosBasic.post(`/sam/v1/SupplierDeclaration/insertOrUpdate?professionalId=${encodeURIComponent(professionalId)}`, data, config);

      const responseData = await response.data;

      return responseData;

  } catch (e: any) {
      throw e;
  }
};



const exportedObject = {
    postInsertOrUpdateSupplierDeclaration
};
  
  
  export default exportedObject